<div>
    <h3 class="pl-4">
        Please be aware that new IFM Reporting is based on figures excluding
        weekends. This leads to shortened handling times.
    </h3>
    <div class="pl-4" v-if="reportOutdated">
        <h2 class="text-danger">
            Report is outdated.
            <br />
        </h2>
        <h3 class="text-danger">Report date: {{ reportDate }}</h3>
    </div>
    <v-img src="/api/v1.0/cases/reporting/ytd/image"></v-img>
</div>